import script from "./Icon.vue?vue&type=script&lang=tsx"
export * from "./Icon.vue?vue&type=script&lang=tsx"

import "./Icon.vue?vue&type=style&index=0&id=0db59288&lang=scss&scoped=true"

import exportComponent from "/builds/dc/siemens.fm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0db59288"]])

export default __exports__